import { Link } from 'react-router-dom';
import PageWrapper from 'components/layout/PageWrapper';
import SubGallery from 'components/SubGallery';

const images = [
    { src: '/images/TigerFishPhotos/TigerFishBoardView.png', alt: 'Tiger Fish board view' },
    { src: '/images/TigerFishPhotos/Front.png',              alt: 'Tiger Fish front view' },
    { src: '/images/TigerFishPhotos/Iso.png',                alt: 'Tiger Fish isometric view' },
    { src: '/images/TigerFishPhotos/Side.png',               alt: 'Tiger Fish side view' },
];

const buttonStyle = {
    margin: '10px', padding: '10px 20px', fontSize: '18px',
    backgroundColor: 'var(--color-bg-dark)', color: 'var(--color-text)',
    border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer',
};

const PastYear2526 = () => (
    <div style={{ backgroundColor: 'var(--color-bg-dark)', color: 'var(--color-text)' }}>
        <PageWrapper>
            <Link to="/fleet" className="fleet-back-link">← Back to The Fleet</Link>
            <h1 style={{ color: 'var(--color-primary)', fontSize: '60px', textAlign: 'center', fontFamily: "'NCAA Missouri Tigers', Arial" }}>Tiger Fish</h1>
            <p style={{ fontSize: '32px', margin: '0', fontWeight: 'normal', textAlign: 'center' }}>2025-2026</p>
            <br />
            <SubGallery images={images} />
            <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <div style={{ margin: 'auto', maxWidth: '100%', overflow: 'hidden', marginBottom: '20px' }}>
                    <iframe
                        style={{ maxWidth: '100%', width: 'clamp(280px, 90vw, 560px)', height: 'clamp(158px, 50vw, 315px)', border: 'none' }}
                        src="https://www.youtube.com/embed/6KGUhhGTGrE"
                        title="Tiger Fish competition footage"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
                <a href="2526DesignReport.pdf">
                    <button style={buttonStyle}>Tiger Fish Technical Design Report</button>
                </a>
            </div>
        </PageWrapper>
    </div>
);

export default PastYear2526;
